import React from 'react'
import connectEmail from '../../static/connect-email.svg'
import connectFacebook from '../../static/connect-facebook.svg'
import connectInsta from '../../static/connect-insta.svg'
import connectLocation from '../../static/connect-location.svg'
import connectYoutube from '../../static/connect-youtube.svg'
import {
  contactContainer,
  contactContainerImg
} from './contactStyles.module.css'

const Contact = props => {
  return(
  <div className={contactContainer}>
  <div className={contactContainerImg}>
    <a href="mailto:editor@hilltopsphoenix.com.au"><img src={connectEmail} alt="Hilltops Phoenix Email"/></a>
  </div>
  <div className={contactContainerImg}>
    <a href="https://www.google.com/maps/search/?api=1&query=-34.3131847,-148.2959494&query_place_id=ChIJHdcopqD-GWsRI-Sa1wVRy6k"><img src={connectLocation} alt="hilltops Phoenix Loaction"/></a>
  </div>
  <div className={contactContainerImg}>
    <a href="https://www.facebook.com/thehilltopsphoenix"><img src={connectFacebook} alt="Hilltops Phoenix Facebook"/></a>
  </div>
  <div className={contactContainerImg}>
    <a href="https://www.instagram.com/thehilltopsphoenix/"><img src={connectInsta} alt="Hilltops Phoenix Instagram"/></a>
  </div>
  <div className={contactContainerImg}>
    <a href="https://www.youtube.com/channel/UCGCwfxXn95Rn1m9JD0VOKPg"><img src={connectYoutube} alt="Hilltops Phoenix Youtube"/></a>
  </div>
  </div>
  )
}


export default Contact
